import React, { useState, useEffect } from "react";
import Select from "react-select";

import { getDeliver } from "../../service/api/Deliver/apiDeliver";

const SearchArea = ({
    searchForm,
    setSearchForm,
    statusFilter,
    setStatusFilter,
    reviewFilter,
    setReviewFilter,
    onSearch,
    onReset,
    loading
}) => {
    const [drivers, setDrivers] = useState([]);

    useEffect(() => {
        // 從 API 獲取司機列表
        const fetchDrivers = async () => {
            try {
                const response = await getDeliver();
                if (response.status === 200 && response.data.status === 1) {
                    const driversList = response.data.result || [];
                    setDrivers(driversList);
                }
            } catch (error) {
                console.error('獲取司機列表失敗:', error);
            }
        };

        fetchDrivers();
    }, []);
    return (
        <div className="card-body mb-4">
            {/* 頂部區段：第一行 - 申請單編號、姓名、電話 */}
            <div className="search-section">
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <input
                                id="id"
                                name="id"
                                type="text"
                                className="form-control-premium"
                                value={searchForm.id}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, id: e.target.value }))}
                                placeholder="申請單編號"
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <input
                                id="deliverOrderId"
                                name="deliverOrderId"
                                type="text"
                                className="form-control-premium"
                                value={searchForm.deliverOrderId}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, deliverOrderId: e.target.value }))}
                                placeholder="派車單ID"
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <Select
                                inputId="deliverId"
                                name="deliverId"
                                // 顯示司機名稱，value為司機ID，送出時送司機ID
                                options={drivers.map(driver => ({ value: driver.id, label: driver.name }))}
                                value={searchForm.deliverId ? { value: searchForm.deliverId, label: drivers.find(driver => driver.id === searchForm.deliverId)?.name || '' } : null}
                                onChange={(option) => setSearchForm(prev => ({ ...prev, deliverId: option?.value || '' }))}
                                isClearable
                                isSearchable
                                placeholder="-- 選擇司機 --"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderColor: '#dadce0',
                                        borderRadius: '8px',
                                        padding: '2px 8px',
                                        minHeight: '40px',
                                        fontSize: '14px'
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#1f73e6' : state.isFocused ? '#f0f2f5' : 'white',
                                        color: state.isSelected ? 'white' : '#202124'
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* 第二行 - Email、司機、縣市 */}
            <div className="search-section">
                <div className="row g-4">
                    {/* 借出日期 */}
                    <div className="col-lg-4">
                        <div className="date-range-group">
                            <label className="form-label" style={{ fontSize: '0.75rem', color: '#999' }}>借出日期</label>
                            <input
                                id="startAt"
                                name="startAt"
                                type="date"
                                className="form-control-premium"
                                value={searchForm.startAt}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, startAt: e.target.value }))}
                                placeholder="借出日期"
                            />
                        </div>
                    </div>

                    {/* 申請日期 */}
                    <div className="col-lg-4">
                        <div className="date-range-group">
                            <label className="form-label" style={{ fontSize: '0.75rem', color: '#999' }}>申請日期</label>
                            <input
                                id="applicantDate"
                                name="applicantDate"
                                type="date"
                                className="form-control-premium"
                                value={searchForm.applicantDate}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, applicantDate: e.target.value }))}
                                placeholder="申請日期"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* 第三行：日期範圍 + 狀態篩選 */}
            <div className="search-section">
                <div className="row g-4">

                </div>
            </div>

            {/* 動作按鈕 - 搜尋 & 重置 */}
            <div className="search-action-group">
                <button
                    className="btn btn-primary fw-bold"
                    onClick={onSearch}
                    disabled={loading}
                >
                    <i className="fas fa-search me-2"></i>{loading ? '搜尋中...' : '搜尋'}
                </button>
                <button
                    className="btn btn-secondary fw-bold"
                    onClick={onReset}
                >
                    <i className="fas fa-redo me-2"></i>重置
                </button>
            </div>
        </div>
    );
};

export { SearchArea };
